const services = [
  {
    icon: 'ri-scissors-cut-line',
    title: 'Short-Form Editing',
    description: 'Reels, TikToks, YouTube Shorts — we cut your raw footage into scroll-stopping content optimized for each platform.',
  },
  {
    icon: 'ri-music-2-line',
    title: 'Music Layover',
    description: 'We source and sync licensed background music that matches your brand tone and keeps viewers engaged from start to finish.',
  },
  {
    icon: 'ri-mic-line',
    title: 'Voiceover Integration',
    description: 'Send us your voiceover audio or let us arrange one — we blend it seamlessly with your footage and music.',
  },
  {
    icon: 'ri-closed-captioning-line',
    title: 'Captions & Subtitles',
    description: 'Animated, on-brand captions that boost watch time and make your content accessible to every viewer.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Color Grading',
    description: 'Cinematic color correction and grading to give your videos a consistent, professional look that stands out.',
  },
  {
    icon: 'ri-speed-line',
    title: 'Motion Graphics & Text',
    description: 'Eye-catching lower thirds, title cards, transitions, and animated text overlays to elevate your content.',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-[#1E3A8A]/10 text-[#1E3A8A] text-xs font-semibold rounded-full mb-4 tracking-widest uppercase">
            What We Offer
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Everything Your Video Needs</h2>
          <p className="text-gray-600 max-w-xl mx-auto text-base leading-relaxed">
            From raw clips to polished, platform-ready content — we handle every step of the editing process so you don't have to.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#1E3A8A]/10 rounded-xl mb-5 group-hover:bg-[#1E3A8A] transition-colors duration-300">
                <i className={`${service.icon} text-xl text-[#1E3A8A] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
